import axios from 'axios';
import { JsonResponse } from 'core/models/response';

import { Notice, NoticeCreatePayload, NoticeListResponse } from '../models/notice';
import { CheckCompanyShareholder, CompanyShareholder } from 'core/models/shareholder';

export const onGetNoticesList = async (page: number = 1) => {
	try {
		const response = await axios.get<JsonResponse<NoticeListResponse>>('dashboard/actions/notice', {
			params: { page },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetNoticeById = async (id: string) => {
	try {
		const response = await axios.get<JsonResponse<Notice>>(`dashboard/actions/notice/${id}`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCheckCompanyShareholder = async (national_id: string) => {
	try {
		const response = await axios.get<JsonResponse<CheckCompanyShareholder>>(`dashboard/actions/notice/check-company-shareholder`, {
			params: { national_id },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onCreateNotice = async (payload: NoticeCreatePayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/actions/notice`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
